import * as XLSX from "xlsx";

export function sanitizeFileName(fileName, fallback) {
  return String(fileName || fallback)
    .trim()
    .replace(/[^a-zA-Z0-9-_ ]/g, "")
    .replace(/\s+/g, "_") || fallback;
}

function sanitizeSheetName(sheetName) {
  const sanitized = String(sheetName || "Export")
    .replace(/[\\/*?:[\]]/g, "")
    .trim();

  return (sanitized || "Export").slice(0, 31);
}

export function exportWorkbookSheets(sheets, fileName) {
  const workbook = XLSX.utils.book_new();

  (sheets || []).forEach((sheet, index) => {
    const rows = Array.isArray(sheet?.rows) ? sheet.rows : [];
    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      sanitizeSheetName(sheet?.sheetName || `Sheet ${index + 1}`)
    );
  });

  XLSX.writeFile(workbook, `${sanitizeFileName(fileName, "export")}.xlsx`);
}

export function exportWorkbook(rows, fileName, sheetName = "Export") {
  exportWorkbookSheets([{ sheetName, rows }], fileName);
}
